import axios from "axios";

import { Auth } from "../../Helpers";

const Amedia = {
  namespaced: true,
  state: {
    mantenimiento: false,
    login: {
      load: true,
      success: false,
      error: "",
      e: "",
      data: {
        access_token: null,
        name: null,
      },
    },
    check: {
      load: true,
      success: false,
    },
  },
  actions: {
    logout: async function ({ commit, rootGetters }) {
      let api = rootGetters["ApiTransferencias/getAmediaLogout"];

      await axios
        .post(api)
        .then((r) => {
          console.log(r);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    check: async function ({ commit, rootGetters }) {
      commit("setCheck", { type: "load", value: true });
      commit("setCheck", { type: "success", value: false });

      let api = rootGetters["ApiTransferencias/getAmediaCheck"];

      await axios
        .post(api)
        .then((r) => {
          commit("setCheck", { type: "load", value: false });

          if (r.data.success) {
            commit("setCheck", { type: "success", value: true });
          } else {
            commit("setCheck", { type: "success", value: false });
            Auth().logout();
            console.log("check fail");
            //document.location.reload();
          }
        })
        .catch((e) => {
          console.log(e);
          commit("setCheck", { type: "load", value: false });

          if (!!e.response.status && e.response.status == 401) {
            commit("setCheck", { type: "success", value: false });
            Auth().logout();
            Auth().console("Tirar mensaje Token caducado!");
          }
        });
    },
    login: async function ({ commit, rootGetters }, token) {
      commit("resetLogin");

      let api = rootGetters["ApiTransferencias/getAmediaLogin"];

      await axios
        .post(
          api,
          {},
          {
            headers: {
              "Content-type": "application/json",
              "x-web-token": token,
            },
          }
        )
        .then((r) => {
          commit("setLogin", { type: "load", value: false });

          if (r.data.success) {
            commit("setLogin", { type: "success", value: true });
            commit("setLogin", {
              type: "data",
              value: {
                access_token: r.data.data.user.access_token,
                name: r.data.data.user.name,
              },
            });
          } else {
            commit("setLogin", { type: "error", value: r.data.data.error });
            commit("setLogin", { type: "e", value: r.data.data.e });
          }
        })
        .catch((e) => {
          console.log("error...");
          commit("setLogin", { type: "load", value: false });

          if (!!e.response.status && e.response.status == 401) {
            commit("setLogin", {
              type: "error",
              value: e.response.data.data.error,
            });
            commit("setLogin", { type: "e", value: e.response.data.data.e });
          } else {
            commit("setLogin", {
              type: "error",
              value: "Hubo un problema en la conexión.",
            });
          }
        });
    },
  },
  mutations: {
    setCheck: function (state, data) {
      state.check[data.type] = data.value;
    },
    setLogin: function (state, data) {
      state.login[data.type] = data.value;
    },
    resetLogin: function (state) {
      state.login.load = true;
      state.login.success = false;
      state.login.data = {
        user_token: null,
        user_name: null,
        user_id: null,
      };
    },
  },
};

export default Amedia;
